import {Component, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {CartService} from "../../../../../core/services/cart.service";
import {CartItem} from "../../../../../core/models/shop/cart-item.model";
import {Totals} from "../../../../../core/models/totals.model";
import {Router} from "@angular/router";

@Component({
    selector: 'add-to-cart-notifier',
    templateUrl: './add-to-cart-notifier.component.html',
    styleUrls: ['./add-to-cart-notifier.component.scss'],
    standalone: false
})
export class AddToCartNotifierComponent implements OnInit, OnChanges, OnDestroy {
    @Input() cartItems: CartItem[] = [];
    @Input() latestItems: CartItem[] = [];
    @Input() addEventId: number | null = null;
    public totals: Totals;
    public show: boolean = false;
    public quantity: number;
    public price: number;
    public names: string;
    public plural: string;
    private hideTimer: ReturnType<typeof setTimeout> | null = null;

    constructor(@Inject(CartService) public cartService: CartService,
                public router: Router) {
    }

    ngOnInit() {
    }

    ngOnChanges(e: SimpleChanges) {
        const addEventChange = e.addEventId;
        const currentLatestItems = this.latestItems ?? [];
        const currentUrl = this.router.url;

        if (!addEventChange || addEventChange.firstChange) {
            return;
        }

        if (!currentLatestItems.length || currentUrl === '/warenkorb') {
            return;
        }

        this.quantity = currentLatestItems.reduce((sum, q) => {
            return sum + (+q.quantity);
        }, 0);
        this.price = currentLatestItems.reduce((totalPrice, p) => {
            return totalPrice + (+p.quantity * p.price);
        }, 0.0);
        this.names = currentLatestItems.map(i => i.product.name).join(', ');
        this.plural = currentLatestItems.length > 1 ? 'n' : '';
        this.show = true;
        this.totals = this.cartService.calculateTotals();

        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
        }

        this.hideTimer = setTimeout(() => {
            this.show = false;
            this.hideTimer = null;
        }, 4000);
    }

    ngOnDestroy(): void {
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
            this.hideTimer = null;
        }
    }

}
